<template>
	<el-dialog title="" :visible.sync="createdVisible" width="578px" center :close-on-click-modal="false" @close="resetForm">
		<div slot="title" class="postion">
			<i v-if="!isShowDetail" class="iconfont icon-bianji1"></i>
			<span class="download">{{ isShowDetail ? '查看' : !isShowDetail && ruleForm.id ? '编辑' : '新增' }}课程</span>
		</div>
		<RsForm
			ref="rsForm"
			labelwidth="100px"
			:columns="columns"
			:inline="false"
			:saveBtn="true"
			:resetBtn="true"
			:searchBtn="false"
			label-position="top"
			:rules="isShowDetail ? {} : rules"
			:saveLoading="saveLoading"
			@query="onSave"
			@reset="resetForm"
			:isShowDetail="isShowDetail"
		/>
	</el-dialog>
</template>

<script>
export default {
	components: {
		RsForm: () => import('@/components/RsForm/index.vue'),
	},
	data() {
		return {
			createdVisible: false,
			columns: [
				{
					prop: 'name',
					label: '课程名称',
					type: 'input',
					default: '',
				},
				{
					prop: 'contentTypeDictionaryItemId',
					label: '课程类别',
					type: 'select',
					default: null,
					options: [], //接口请求数据后再赋值
					optionsDefault: ['title', 'id'], //[label,value]
				},
				{
					prop: 'lessonTypeDictionaryItemId',
					label: '所属科目',
					type: 'select',
					default: null,
					options: [], //接口请求数据后再赋值
					optionsDefault: ['name', 'id'], //[label,value]
				},
				{
					label: '课程编码',
					type: 'input',
					prop: 'serialNumber',
					default: '',
					className: 'w50 mr16',
				},
				{
					label: '课程定价',
					type: 'input',
					prop: 'price',
					maxlength: 11,
					default: '',
					className: 'w50 mr0',
					inputType: 'number',
					slot: '元',
				},
				{
					prop: 'description',
					label: '课程介绍',
					type: 'textarea',
					default: '',
				},
				{
					label: '课程图片',
					type: 'uploadImg',
					prop: 'images',
					maxCount: 6,
					operator: 'zhangl',
					modulePath: 'LECTURE_LESSON',
				},
			], //表单配置项
			rules: {
				name: [{ required: true, message: '请输入', trigger: 'blur' }],
				lessonTypeDictionaryItemId: [{ required: true, message: '请选择', trigger: 'change' }],
				contentTypeDictionaryItemId: [{ required: true, message: '请选择', trigger: 'change' }],
				description: [{ required: true, message: '请输入', trigger: 'blur' }],
				serialNumber: [{ required: true, message: '请输入', trigger: 'blur' }],
				price: [{ required: true, message: '请输入', trigger: 'blur' }],
				images: [{ required: true, message: '请上传图片', trigger: 'change' }],
			},
			attachmentInfo: {},
			saveLoading: false,
			loading: false,
			ruleForm: {},
			link: '',
		};
	},
	computed: {},
	props: ['isShowDetail'],
	watch: {},
	created() {},
	methods: {
		init({ row, link }) {
			this.createdVisible = true;
			this.getAttachment();
			this.getCourseType();
			this.getSubjectList();
			this.link = link;
			if (row) {
				this.getDetails();
				// this.setRuleForm(row);
				return;
			}
			this.$nextTick(() => {
				this.$refs.rsForm.formData = {};
				this.$refs.rsForm.$refs['queryForm'].resetFields();
			});
		},
		// 获取课程类别
		getCourseType() {
			this.$http
				.get(this.api.getDictionaryItems + '.json', { params: { dictionaryCode: 'LESSON_CONTENT_TYPE', size: 9999, current: 1 } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.columns[1].options = res.data.collection || [];
					}
				})
				.catch((e) => {});
		},
		// 获取附件组
		getAttachment() {
			this.$http
				.get(this.api.getAttachmentGroups, { params: { subjectTypeCode: 'LECTURE_LESSON' } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.attachmentInfo = res.data.collection || [];
					}
				})
				.catch((e) => {});
		},
		// 获取科目列表
		getSubjectList() {
			this.$http
				.get(this.api.getTrainingSubject + '.json', { params: { size: 9999, current: 1 } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.columns[2].options = res.data.collection.filter((item) => item.enabled) || [];
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		getDetails() {
			this.$http
				.get(this.link)
				.then((res) => {
					if (res.data && res.data.success) {
						this.setRuleForm(res.data.collection[0]);
					}
				})
				.catch((e) => {});
		},
		// 设置表单数据
		setRuleForm(data) {
			console.log(data);
			this.ruleForm = JSON.parse(JSON.stringify(data));
			let params = {
				...data,
				price: data.price / 100 || '',
				lessonTypeDictionaryItemId: data.lessonTypeDictionaryItem ? JSON.parse(JSON.stringify(data.lessonTypeDictionaryItem.id)) : null,
				images:
					(data.attachmentMap &&
						data.attachmentMap['PHOTO'] &&
						data.attachmentMap['PHOTO'].map((item) => {
							return {
								url: item.link,
								uid: item.id,
								title: item.title,
							};
						})) ||
					[],
			};
			this.$nextTick(() => {
				this.$refs.rsForm.formData = JSON.parse(JSON.stringify(params));
			});
		},
		// 保存
		onSave(data) {
			this.saveLoading = true;
			let par = {
				...data,
				price: JSON.parse(data.price) * 100,
				famousTeacherLectureId: this.$route.query.id,
				attachments: data.images.map((item) => {
					return {
						link: item.url,
						subjectTypeCode: this.attachmentInfo.find((item) => item.code == 'PHOTO').subjectTypeCode,
						title: item.title,
						attachmentGroupId: this.attachmentInfo.find((item) => item.code == 'PHOTO').id,
						mimeType: item.title.split('.')[1],
					};
				}),
			};
			let primoseUrl = this.ruleForm.id ? this.$http.put(this.link, par) : this.$http.post(this.link, par);
			primoseUrl
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success(this.ruleForm.id ? '修改成功' : '添加成功');
						this.$emit('getList');
						this.resetForm();
						this.saveLoading = false;
					}
				})
				.catch((e) => {
					this.saveLoading = false;
				});
		},
		resetForm() {
			this.ruleForm = {};
			this.$refs.rsForm.formData.images = [];
			this.createdVisible = false;
			this.$nextTick(() => {
				this.$refs.rsForm.formData = {};
				this.$refs.rsForm.$refs['queryForm'].resetFields();
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.postion {
	font-size: 18px;
	.icon-bianji1 {
		margin-right: 16px;
		color: #1db9b1;
	}
}
/deep/ .el-form {
	.el-form-item {
		.el-select,
		.el-input {
			width: 100%;
		}
	}

	.el-form-item__label {
		line-height: 14px;
		height: 14px;
		margin-bottom: 8px;
		padding: 0;
	}
}
/deep/ .el-button {
	margin-left: 16px;
}
.fileList {
	&-title {
		margin-bottom: 8px;
		div {
			width: 56px;
			line-height: 14px;
			padding-bottom: 9px;
			color: #999999;
			margin-right: 32px;
			cursor: pointer;
		}
	}
	.activeClass {
		color: #333333;
		border-bottom: 3px solid #333333;
		box-sizing: border-box;
	}
	/deep/ .el-table {
		th.el-table__cell {
			padding: 8px 0;
			> .cell {
				color: #999999;
				font-size: 14px;
				font-weight: normal;
			}
		}
		td.el-table__cell {
			padding: 10px 0;
			border-bottom: none;
			div {
				line-height: 20px;
				height: 20px;
			}
		}
	}
	.textbookName {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		img {
			margin-right: 8px;
			width: 20px;
			height: 20px;
		}
	}
}
</style>